import {Component, OnInit, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';
import {CdkDragDrop, DragDropModule, moveItemInArray} from '@angular/cdk/drag-drop';
import {KanbanService} from './service/kanban.service';
import {KanbanList} from "./api/kanban";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {ProgressBarModule} from "primeng/progressbar";
import {AvatarModule} from "primeng/avatar";
import {AvatarGroupModule} from "primeng/avatargroup";
import {InputTextModule} from "primeng/inputtext";
import {ChipsModule} from "primeng/chips";
import {CalendarModule} from "primeng/calendar";
import {DropdownModule} from "primeng/dropdown";
import {InputTextareaModule} from "primeng/inputtextarea";
import {SidebarModule} from "primeng/sidebar";
import {MenuModule} from "primeng/menu";
import {InplaceModule} from "primeng/inplace";
import {AutoCompleteModule} from "primeng/autocomplete";
import {TooltipModule} from "primeng/tooltip";
import {TieredMenuModule} from "primeng/tieredmenu";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {CheckboxModule} from "primeng/checkbox";
import {KanbanSidebarComponent} from "./kanban-sidebar/kanban-sidebar.component";
import {KanbanListComponent} from "./kanban-list/kanban-list.component";

@Component({
    selector: 'app-kanban-parent-component',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        DragDropModule,
        ButtonModule,
        RippleModule,
        ProgressBarModule,
        AvatarModule,
        AvatarGroupModule,
        InputTextModule,
        ChipsModule,
        CalendarModule,
        DropdownModule,
        InputTextareaModule,
        SidebarModule,
        MenuModule,
        InplaceModule,
        AutoCompleteModule,
        TooltipModule,
        TieredMenuModule,
        OverlayPanelModule,
        CheckboxModule,
        KanbanSidebarComponent,
        KanbanListComponent,

    ],
    providers: [
        KanbanService,
    ],
    templateUrl: './kanban.app.component.html',
    styleUrls: ['./kanban.app.component.scss']
})
export class KanbanAppComponent implements OnInit, OnDestroy {

    sidebarVisible: boolean = false;

    lists: KanbanList[] = [];

    listIds: string[] = [];

    subscription = new Subscription();

    style!: HTMLStyleElement;

    isMobileDevice: boolean = false;

    projects: string[] | undefined;

    selectedProject: | undefined;

    constructor(private kanbanService: KanbanService) {
        this.subscription = this.kanbanService.lists$.subscribe(data => {
            this.lists = data;
            this.listIds = this.lists.map(l => l.listId || '');
        });
    }

    ngOnInit() {
        this.removeLayoutResponsive();
        this.isMobileDevice = this.kanbanService.isMobileDevice();

        this.projects = [
            'ALL',
            'TK',
            'ITA'
        ];
    }

    onProjectSelection() {
        this.subscription = this.kanbanService.lists$.subscribe(data => {
            this.lists = data;
            this.listIds = this.lists.map(l => l.listId || '');
        });

        if (this.selectedProject != 'ALL') {
            this.lists = this.lists.map(list => {
                const filteredCards = list.cards.filter(card => card.project === this.selectedProject);
                return {
                    listId: list.listId,
                    title: list.title,
                    cards: filteredCards
                };
            })
        }
    }

    toggleSidebar() {
        this.sidebarVisible = true;
    }

    addList() {
        this.kanbanService.addList();
    }

    dropList(event: CdkDragDrop<KanbanList[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }

    removeLayoutResponsive() {
        this.style = document.createElement('style');
        this.style.innerHTML = `
                .layout-content {
                    width: 100%;
                }

                .layout-topbar {
                    width: 100%;
                }
            `;
        document.head.appendChild(this.style);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        document.head.removeChild(this.style)
    }
}
